export default "__VITE_ASSET__CFOo3jfJ__"